interface SlideInfo {
  title: string;
  desc: string;
}

const slideInfo: SlideInfo[] = [
  {
    title: 'カレンダー画面',
    desc: '友達と会った日付をカレンダーで確認できます',
  },
  {
    title: 'ランキング画面',
    desc: '友達とのスタンプ数を比較して競います',
  },
  {
    title: 'スタンプコレクション画面',
    desc: '収集したスタンプを一覧で確認できます',
  },
];

let currentSlide = 0;
let autoAdvanceInterval: number;

export function initSlideshow(): void {
  currentSlide = 0;

  const slides = document.querySelectorAll('.slide');
  const slideDots = document.querySelectorAll('.slide-dot');
  const totalSlides = slides.length;

  if (totalSlides === 0) return;

  function showSlide(n: number): void {
    slides.forEach((slide) => slide.classList.remove('active'));
    slideDots.forEach((dot) => dot.classList.remove('active'));

    slides[n].classList.add('active');
    slideDots[n].classList.add('active');

    const titleEl = document.getElementById('slideshow-title');
    const descEl = document.getElementById('slideshow-desc');

    if (titleEl) titleEl.textContent = slideInfo[n].title;
    if (descEl) descEl.textContent = slideInfo[n].desc;
  }

  function nextSlide(): void {
    currentSlide = (currentSlide + 1) % totalSlides;
    showSlide(currentSlide);
  }

  function prevSlide(): void {
    currentSlide = (currentSlide - 1 + totalSlides) % totalSlides;
    showSlide(currentSlide);
  }

  // Event listeners for navigation buttons
  const nextBtn = document.querySelector('.slide-nav.next');
  const prevBtn = document.querySelector('.slide-nav.prev');

  nextBtn?.addEventListener('click', nextSlide);
  prevBtn?.addEventListener('click', prevSlide);

  // Event listeners for dot buttons
  slideDots.forEach((dot, index) => {
    dot.addEventListener('click', () => {
      currentSlide = index;
      showSlide(currentSlide);
    });
  });

  // Auto-advance slideshow every 5 seconds
  autoAdvanceInterval = window.setInterval(nextSlide, 5000);

  // Show first slide
  showSlide(0);
}

export function destroySlideshow(): void {
  if (autoAdvanceInterval) {
    clearInterval(autoAdvanceInterval);
  }
}
